export class InvalidSvgError extends Error {
  constructor (...args) {
    super(...args);
    this.message = 'Page content is not a valid SVG';
  }
}
